import request from "@/helper/request";

// 登录方法
export function getTempToken(data) {
  return request({
    url: "/json/base/token",
    method: "post",
    data: data,
  });
}
// 获取验证码
export function getCodeCaptcha(val) {
  const data = {
    "req": {
      "width": 100,
      "height": val || 40,
      "background": "#fefefe",
      "fontSize": 40
    }
  }
  return request({
    url: "/captcha/get?v=" + Date.now(),
    method: "post",
    data: data,
  });
}
export function login(account, password, code, uuid) {
  const data = {
    "req": {
      "username": account,
      "password": password,
      "captcha": code,
    }
  };
  return request({
    url: "/json/member/login",
    method: "post",
    data: data,
  });
}
// 会员用户登录【短信验证码登录】
export function smslogin(data) {
  return request({
    url: "/json/member/codeLogin",
    method: "post",
    data,
  });
}

// 获取用户详细信息
export function getUserInfo() {
  return request({
    url: "/api/v1/account/user",
    method: "get",
  });
}

// 获取用户详细信息
export function getInfo(account) {
  return request({
    url: "/authsystem/amUser/userPermissions?account=" + account,
    method: "get",
  });
}

// 获取用户详细信息
export function getUserPerms(account) {
  return request({
    url: "/authsystem/amPerm/getUserPerms?account=" + account,
    method: "get",
  });
}

// 获取用户详细信息
// export function getInfo() {
//   return request({
//     url: "/getInfo",
//     method: "get",
//   });
// }

// 退出方法
export function logout() {
  return request({
    url: "/api/v1/account/logout",
    method: "post",
  });
}

// 获取验证码
/* export function getCodeImg() {
  return request({
    url: "/captchaImage",
    method: "get",
  });
} */
// http://tjport.dpi-earth.com:18000/api/v1/account/code_image
// 获取验证码
export function getCodeImg() {
  return request({
    url: "/api/v1/account/code_image",
    method: "get",
  });
}

//获取token

export function getuOpticToken() {
  return request({
    url: "/verify/token",
    method: "get",
  });
}


